import { getAuth } from 'firebase/auth';

export const getCurrentUser = () => {
  return getAuth().currentUser;
};

export async function getUserToken() {
  return await getAuth().currentUser?.getIdToken();
}

export async function getUserEmail() {
  return getAuth().currentUser?.email as string;
}
